// Jerarquía competencia -> subcompetencias y nombres visibles, tomados de
// la misma estructura ya usada en ResulParte1.vue / ResulLiderParte1.vue
// (estructura/nombres en su data()), para no duplicar el mapeo una tercera vez.

export const estructura = {
  categorias: ['general', 'cond', 'resuld', 'dsmd', 'gperd', 'reld', 'autoconciencia'],
  general: [],
  cond: [],
  resuld: ['cambiod', 'logrod'],
  dsmd: ['humid', 'autogd'],
  gperd: [],
  reld: ['cefectivad', 'asertivad', 'cercaniad', 'rad'],
  autoconciencia: []
}

export const nombres = {
  general: 'Líder PHD',
  cond: 'Gestión del Conocimiento',
  resuld: 'Gestión de Resultados',
  cambiod: 'Cambio y Toma de Decisiones',
  logrod: 'Logro',
  dsmd: 'Gestión de Sí Mismo',
  humid: 'Humildad',
  autogd: 'Autogestión',
  gperd: 'Gestión de Personas',
  reld: 'Gestión de Relaciones',
  cefectivad: 'Comunicación Efectiva',
  asertivad: 'Asertividad',
  cercaniad: 'Cercanía',
  rad: 'Retroalimentación',
  autoconciencia: 'Autoconciencia'
}

export const iconos = {
  general: 'military_tech',
  cond: 'menu_book',
  resuld: 'trending_up',
  dsmd: 'self_improvement',
  gperd: 'groups',
  reld: 'forum',
  autoconciencia: 'psychology'
}



// WEBPACK FOOTER //
// ./src/components/lideres/helpers/estructuraLider.js